import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { LocaleFeaturedLink } from 'typescriptDefs/layout';

import { LocaleContext } from '../Layout';
import { P } from '../Typography';
import { NavLink, SectionTitle } from './NavTypography';

export const FeaturedLink = ({
  darkBg,
  featured: { description, image, linkText, title, url },
  trackLinkClicked,
}: {
  darkBg: boolean;
  featured: LocaleFeaturedLink;
  trackLinkClicked: (label: string) => void;
}) => {
  const locale = useContext(LocaleContext);

  return (
    <div className="lg:ml-auto">
      <SectionTitle className="mb-8 lg:mb-16" darkBg={darkBg}>
        {{ en: 'Featured', fr: 'En vedette' }[locale]}
      </SectionTitle>
      <div className="flex flex-col gap-12 md:flex-row md:gap-16">
        <GatsbyImage
          className="h-full max-w-200 rounded-8"
          image={image.img.asset.gatsbyImageData}
          alt={image.altText}
          role="presentation"
        />
        <div className="lg:max-w-200">
          <P className={twMerge(clsx('mb-4 text-md font-medium', darkBg && 'text-white'))}>{title}</P>
          <P className={twMerge(clsx('mb-4 text-sm text-grey-450 md:text-sm', darkBg && 'text-grey-100'))}>
            {description}
          </P>
          <NavLink
            className="mb-0"
            darkBg={darkBg}
            item={{ title: linkText, url }}
            onClick={() => trackLinkClicked(`Featured - ${title}`)}
          />
        </div>
      </div>
    </div>
  );
};
